import { useT } from "../../../../i18n";
import { toNumberOrNull } from "../../../../utils/energyDevices";
import { formatWatt } from "./EnergyKpi";
import "./EnergyInsight.css";

// fog 구성에서 큐브가 받은 · 보낸 전력 한 줄.
// 값이 둘 다 null 이면(하드웨어가 아직 안 보내면) 그리지 않는다 — 빈 줄을 두면 고장처럼 보인다.
export default function SharedPowerLine({ latest }) {
  const t = useT();
  const inW = toNumberOrNull(latest?.sharedInW);
  const outW = toNumberOrNull(latest?.sharedOutW);
  if (inW == null && outW == null) return null;

  const hint =
    inW > 0
      ? t("energy.shared.hint.receiving")
      : outW > 0
        ? t("energy.shared.hint.giving")
        : t("energy.shared.hint.none");

  return (
    <div className="ei-share">
      <span>
        ⇣ {t("energy.shared.in")} <b>{formatWatt(inW)} W</b>
      </span>
      <span>
        ⇡ {t("energy.shared.out")} <b>{formatWatt(outW)} W</b>
      </span>
      <span className="ei-share-hint">{hint}</span>
    </div>
  );
}
